import { Hamburger } from "../../BaseComponents/Icons/Svg";
import { useSelector, useDispatch } from "react-redux";
import { mobileMenuActions } from "../../framework/redux/actions/index";
import { BurgerButtonWrapper } from "./BurgerButtonWrapper";
import React, { useEffect } from "react";

export const HamburgerButton = () => {
	const state = useSelector(({ mobileMenu }) => mobileMenu);
	const dispatch = useDispatch();

	let handleClick = (e) => {
		e.preventDefault();
		dispatch(mobileMenuActions.toggle(state.show));
	};
	let className = state.show ? "open" : "";

	return (
		<BurgerButtonWrapper onClick={(e) => handleClick(e)}>
			<span className={className}></span>
			<span className={className}></span>
			<span className={className}></span>
			<span className={className}></span>
		</BurgerButtonWrapper>
	);
};
